<template>
  <div class="popup-tableSelect popup-aside-float">
    <div class="popup-tableSelect-container">
      <div class="popup-tableSelect-header">
        <div class="popup-tableSelect-nbCouvert">{{ getNbCouvertsTotal }}</div>
        <div class="nav-toggle" @click="closePopup">
          <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
        </div>
      </div>
      <div class="popup-tableSelect-desc" v-if="!getModSwitchTable">
        <div v-if="getSelectedTables.length === 1">Table</div>
        <div v-if="getSelectedTables.length > 1">Tables</div>
        <div>{{ getSelectedTablesToString }}</div>
      </div>
      <div class="popup-tableSelect-btns black-inputs">
        <div v-if="getGeneraleState === 'PASSAGE' && !passageOpen && !getModSwitchTable">
          <el-button v-if="inCurrentService() && getTableIsAvaible && getLockButtonState === 0" class="dark"
            type="primary" @click="passageOpen = true">Passage</el-button>
          <el-button v-if="getLockButtonState === 0 && getCanBeInverted" class="dark" type="primary"
            @click="invertAttribution()">Inverser le placement</el-button>
          <el-button v-if="getLockButtonState === 0 && getHoursDispoForSelectedTable().length > 0" class="dark"
            type="primary" @click="takeResaOnThisTable">Prendre une réservation</el-button>
          <el-button v-if="getLockButtonState === 0 && getSelectedTables.length === 1 && getNumberOfResa > 0"
            class="dark" type="primary" @click="setModeChangeTable('START')">Changer Table</el-button>
          <el-button v-if="getLockButtonState === 0 && getNumberOfResa <= 0" :disabled="btnLockTable" class="dark"
            type="primary" @click="lockThisTable(true)">Bloquer la table</el-button>
          <el-button v-if="getLockButtonState === 1" :disabled="btnLockTable" class="dark" type="primary"
            @click="lockThisTable(false)">Débloquer la table</el-button>
          <el-button v-if="getLockButtonState === 0 && getTableIsOccuped" class="dark" type="primary"
            @click="unLinkTableToResa('SHOW')">Libérer table</el-button>
          <el-button v-if="getLockButtonState === 0 && getTableIsComming" class="dark" type="primary"
            @click="unLinkTableToResa('CONFIRMED')">Désatribuer table</el-button>
        </div>
        <div v-if="getGeneraleState === 'PASSAGE' && passageOpen && !getModSwitchTable">
          <div>Passage - Nombre de couverts</div>
          <el-input-number class="text-centered dark" size="medium" :min="1"
            v-model="passageNbCouvert"></el-input-number>
          <div v-loading="btnTakeResa">
            <el-button v-if="!btnTakeResa" type="primary" @click="validerPassage">Valider</el-button>
          </div>
        </div>
        <div v-if="getGeneraleState === 'DISPOS' && !getModSwitchTable">
          <el-button class="dark" type="primary" @click="unLinkTable">Libérer la table</el-button>
          <el-button class="dark" type="primary" @click="lockTable">Bloquer la table</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Notification } from 'element-ui';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import * as resaState from '../../store/types/resa-state';
import { compareTime, formatTime, nextTime, previousTime } from '../../tools/timeTool';

export default {
  name: 'PopupTableSelected',
  data() {
    return {
      passageOpen: false,
      passageNbCouvert: 2,
      btnTakeResa: false,
      btnLockTable: false
    }
  },
  computed: {
    ...mapGetters({
      getSelectedTables: 'newRooms/getSelectedTables',
      getSelectedRoom: 'newRooms/getSelectedRoom',
      getLinkedResaIdsToTable: 'newRooms/getLinkedResaIdsToTable',
      isVisiblePopupManageServices: 'displayer/isVisiblePopupManageServices',
      getDisplayTableById: 'newRooms/getDisplayTableById',
      getSelectedResaState: 'newReservations/getSelectedResaState',
      getSelectedResa: 'newReservations/getSelectedResa',
      getCurrentResaById: 'newReservations/getCurrentResaById',
      getSelectedMainServiceData: 'newServices/getSelectedMainServiceData',
      getClientByid: 'newClients/getClientByid',
      getSelectedDay: 'calendar/getSelectedDay',
      getSelectedSubService: 'newServices/getSelectedSubService',
      getSelectedMainService: 'newServices/getSelectedMainService',
      inCurrentService: 'newServices/inCurrentService',
      getCurrentLockedTables: 'newRooms/getCurrentLockedTables',
      getThisTableIsLock: 'newRooms/getThisTableIsLock',
      getHoursDispoForSelectedTable: 'newRooms/getHoursDispoForSelectedTable',
      getModSwitchTable: 'newReservations/getModSwitchTable',
      getResaToSwitch1: 'newReservations/getResaToSwitch1',
      getResaToSwitch2: 'newReservations/getResaToSwitch2',
      getFloatingSwitchTables: 'newReservations/getFloatingSwitchTables',
      getUidPublic: 'newUsers/getUidPublic'
    }),
    getTableIsAvaible: function () {
      let found = false
      let lenghtService = this.getSelectedMainServiceData.lenghtService
      let limitSecu = this.getSelectedMainServiceData.limitSecuChrono
      let now = new Date()
      let currentTime = formatTime({
        hours: now.getHours(),
        minutes: now.getMinutes()
      })
      this.getSelectedTables.forEach((tid) => {
        let tabResas = this.getLinkedResaIdsToTable(this.getSelectedRoom, tid)
        if (tabResas && tabResas.length > 0) {
          tabResas.forEach((rid) => {
            let resa = this.getCurrentResaById(rid)
            let hStartHour = previousTime(resa.hour, limitSecu)
            let hEndResa = nextTime(resa.hour, lenghtService)
            if (compareTime(currentTime, hStartHour) >= 0 && compareTime(currentTime, hEndResa) < 0) {
              found = true
              return false
            }
          })
        }
      })
      return !found
    },
    getTableIsOccuped: function () {
      let found = false
      this.getSelectedTables.forEach((tid) => {
        found = false
        let tabResas = this.getLinkedResaIdsToTable(this.getSelectedRoom, tid)
        if (tabResas && tabResas.length > 0) {
          tabResas.forEach((rid) => {
            let resa = this.getCurrentResaById(rid)
            if (resa.state === resaState.SHOW) found = true
          })
        }
      })
      return found
    },
    getTableIsComming: function () {
      let allComming = true
      this.getSelectedTables.forEach((tid) => {
        let tabResas = this.getLinkedResaIdsToTable(this.getSelectedRoom, tid)
        if (!tabResas || tabResas.length === 0) allComming = false
        if (tabResas && tabResas.length > 0) {
          tabResas.forEach((rid) => {
            let resa = this.getCurrentResaById(rid)
            if (resa.state !== resaState.CONFIRMED) allComming = false
          })
        }
      })
      return allComming
    },
    getNumberOfResa: function () {
      let countTab = []
      if (this.getSelectedTables.length === 0) return 0
      this.getSelectedTables.forEach((tid) => {
        let tabResas = this.getLinkedResaIdsToTable(this.getSelectedRoom, tid)
        if (tabResas && tabResas.length > 0) {
          tabResas.forEach((resaId) => {
            let found = countTab.find((frid) => {
              return frid === resaId
            })
            if (!found) countTab.push(resaId)
          })
        }
      })
      return countTab.length
    },
    getCanBeInverted: function () {
      let resas = []
      if (this.getSelectedTables.length === 1) return false
      this.getSelectedTables.forEach((tid) => {
        let tabResas = this.getLinkedResaIdsToTable(this.getSelectedRoom, tid)
        if (tabResas && tabResas.length > 0) {
          tabResas.forEach((rid) => {
            let found = resas.findIndex((frid) => {
              return frid.resaId === rid
            })
            if (found === -1) resas.push({ resaId: rid, tableId: tid, count: 1 })
            else resas[found].count += 1
          })
        }
      })
      if (resas.length === 2) {
        let found = resas.find((frid) => {
          return frid.count > 1
        })
        if (found === undefined) return true
        else return false
      } else {
        return false
      }
    },
    getLockButtonState: function () {
      let countLock = 0
      this.getSelectedTables.forEach((tId) => {
        let tableIsLock = this.getThisTableIsLock({
          date: this.getSelectedDay,
          service: this.getSelectedMainService,
          room: this.getSelectedRoom,
          id: tId
        })
        if (tableIsLock) countLock += 1
      })
      if (countLock === 0) return 0
      else if (countLock === this.getSelectedTables.length) return 1
      else return -1
    },
    getNbCouvertsTotal: function () {
      let nbTotal = 0
      this.getSelectedTables.forEach((table) => {
        if (this.getDisplayTableById(table) !== undefined) nbTotal += this.getDisplayTableById(table).nbCouvert
      })
      return nbTotal
    },
    getSelectedTablesToString: function () {
      let tmp = this.getSelectedTables
      tmp.sort(function (a, b) {
        return a - b
      })
      let str = ''
      for (let i = 0; i < tmp.length; i++) {
        str += tmp[i].toString()
        if (i !== tmp.length - 1) str += ', '
      }
      return str
    },
    getTablesRTS1ToString: function (array) {
      let tmp = this.getResaToSwitch1.tids
      tmp.sort(function (a, b) {
        return a - b
      })
      let str = ''
      for (let i = 0; i < tmp.length; i++) {
        str += tmp[i].toString()
        if (i !== tmp.length - 1) str += ', '
      }
      return str
    },
    getTablesRTS2ToString: function (array) {
      let tmp = this.getResaToSwitch2.tids
      tmp.sort(function (a, b) {
        return a - b
      })
      let str = ''
      for (let i = 0; i < tmp.length; i++) {
        str += tmp[i].toString()
        if (i !== tmp.length - 1) str += ', '
      }
      return str
    },
    getTablesFTSToString: function (array) {
      let tmp = this.getFloatingSwitchTables
      tmp.sort(function (a, b) {
        return a - b
      })
      let str = ''
      for (let i = 0; i < tmp.length; i++) {
        str += tmp[i].toString()
        if (i !== tmp.length - 1) str += ', '
      }
      return str
    },
    getGeneraleState: function () {
      if (this.isVisiblePopupManageServices) {
        switch (this.getSelectedResaState) {
          case resaState.TO_CONFIRM:
          case resaState.NEED_TABLE:
            return 'NO_TABLE'
          case resaState.CONFIRMED:
          case resaState.SHOW:
          case resaState.NO_SHOW:
          case resaState.CANCELLED:
            return 'DISPOS'
        }
      } else {
        return 'PASSAGE'
      }
    }
  },
  methods: {
    ...mapMutations({
      setPopupTableSelected: 'displayer/setPopupTableSelected',
      setPopupTakeResa: 'displayer/setPopupTakeResa',
      setModSwitchTable: 'newReservations/setModSwitchTable',
      setResaToSwitch1: 'newReservations/setResaToSwitch1',
      setResaToSwitch2: 'newReservations/setResaToSwitch2',
      setSelectedTables: 'newRooms/setSelectedTables'
    }),
    ...mapActions({
      updateTablesLinked: 'newReservations/updateTablesLinked',
      createNewResa: 'newReservations/createNewResa',
      unLinkTables: 'newReservations/unLinkTables',
      unSelectedTables: 'newRooms/unSelectedTables',
      createNewClient: 'newClients/createNewClient',
      updateCurrentServiceLockedTables: 'newRooms/updateCurrentServiceLockedTables'
    }),
    closePopup: function () {
      this.passageOpen = false
      this.setPopupTableSelected(false)
      this.unSelectedTables()
    },
    setModeChangeTable: function (val) {
      this.setPopupTableSelected(false)
      this.setModSwitchTable(true)
      let resas = this.findResaIdBySelectedTables()
      if (resas.length === 1) {
        let resa1 = this.getCurrentResaById(resas[0])
        let resa1tables = resa1.tids.slice(0)
        this.setResaToSwitch1({
          state: resa1.state,
          data: resa1,
          tids: resa1tables,
          room: resa1.room
        })
        this.setSelectedTables(resa1tables)
      }
    },
    findResaIdBySelectedTables: function () {
      let resas = []
      this.getSelectedTables.forEach((tid) => {
        let tabResas = this.getLinkedResaIdsToTable(this.getSelectedRoom, tid)
        if (tabResas && tabResas.length > 0) {
          tabResas.forEach((rid) => {
            let found = resas.find((frid) => {
              return frid === rid
            })
            if (found === undefined) resas.push(rid)
          })
        }
      })
      // sort resa by time
      resas.sort((a, b) => {
        return compareTime(this.getCurrentResaById(a).hour, this.getCurrentResaById(b).hour)
      })
      return resas
    },
    invertAttribution: function () {
      let resas = this.findResaIdBySelectedTables()
      if (resas.length === 2) {
        let resa1 = this.getCurrentResaById(resas[0])
        let resa1tables = resa1.tids.slice(0)
        let resa2 = this.getCurrentResaById(resas[1])
        let resa2tables = resa2.tids.slice(0)
        this.updateTablesLinked({
          state: resa1.state,
          data: resa1,
          tids: resa2tables,
          room: resa2.room
        })
        this.updateTablesLinked({
          state: resa2.state,
          data: resa2,
          tids: resa1tables,
          room: resa1.room
        })
        this.closePopup()
      }
    },
    validerPassage: function () {
      // get or create passager client
      this.btnTakeResa = true
      let createPromise = new Promise(async (resolve, reject) => {
        if (this.getClientByid('passage') === undefined) {
          let pData = {
            civ: '',
            cid: 'passage',
            comment: '',
            email: '-----',
            name: 'Passage',
            prenom: '',
            societe: '',
            rgpdmail: false,
            rgpdsms: false,
            tel: '',
            restoid: this.getUidPublic
          }
          await this.createNewClient(pData)
        }
        resolve()
      })
      // if client exist we can create resa
      createPromise.then(() => {
        let now = new Date()
        let currentTime = formatTime({
          hours: now.getHours(),
          minutes: now.getMinutes()
        })
        // check if previous resa on same table
        this.getSelectedTables.forEach((tid) => {
          let allResaLinked = []
          let tabResas = this.getLinkedResaIdsToTable(this.getSelectedRoom, tid)
          if (tabResas && tabResas.length > 0) {
            tabResas.forEach((rid) => {
              allResaLinked.push(rid)
            })
          }
          if (allResaLinked.length > 0) {
            allResaLinked.forEach((rId) => {
              let resa = this.getCurrentResaById(rId)
              if (compareTime(resa.hour, currentTime) < 0) {
                // if exist if state SHOW -> DONE free table
                if (resa.state === resaState.SHOW) {
                  this.updateTablesLinked({
                    state: resaState.DONE,
                    data: resa,
                    tids: resa.tids,
                    room: resa.room
                  })
                  // if exist if state CONFIRMED -> NO_SHOW
                } else if (resa.state === resaState.CONFIRMED) {
                  this.unLinkTables({ stateResa: resaState.NO_SHOW, resa: resa })
                }
              }
            })
          }
        })
        // create resa data for passager
        let rData = {
          nbCouvert: this.passageNbCouvert,
          room: this.getSelectedRoom,
          tids: this.getSelectedTables,
          rgpdmail: false,
          rgpdsms: false,
          date2: {
            hour: currentTime,
            ms: this.getSelectedMainService,
            subs: this.getSelectedSubService
          }
        }
        // take passage resa
        this.createNewResa({ cid: 'passage', data: rData, date: this.getSelectedDay, state: resaState.SHOW, source: 'Restaurant' }).then((data) => {
          Notification.success({
            title: 'Réservation de passage prise',
            position: 'bottom-right'
          })
          this.closePopup()
        },
          function (err) {
            Notification.error({
              title: 'Error',
              message: err.message,
              position: 'bottom-right'
            })
          })
      })
    },
    unLinkTableToResa: function (checkedState) {
      this.getSelectedTables.forEach((tid) => {
        let tabResas = this.getLinkedResaIdsToTable(this.getSelectedRoom, tid)
        if (tabResas && tabResas.length > 0) {
          tabResas.forEach((rid) => {
            let resa = this.getCurrentResaById(rid)
            if (resa.state === resaState.SHOW && resaState.SHOW === checkedState) {
              this.updateTablesLinked({
                state: resaState.DONE,
                data: resa,
                tids: resa.tids,
                room: resa.room
              })
            } else if (resaState.CONFIRMED === checkedState) {
              let newTabTids = resa.tids
              let index = newTabTids.indexOf(tid)
              let room = resa.room
              if (index > -1) newTabTids.splice(index, 1)
              if (newTabTids.length === 0) room = ''
              this.updateTablesLinked({
                state: resaState.CONFIRMED,
                data: resa,
                tids: newTabTids,
                room: room
              })
            }
          })
        }
      })
      this.unSelectedTables()
    },
    lockThisTable: function (val) {
      if (!this.btnLockTable) {
        this.btnLockTable = true
        let tablesIdsLocked = this.getCurrentLockedTables({
          date: this.getSelectedDay,
          service: this.getSelectedMainService,
          room: this.getSelectedRoom
        }).slice()
        if (val) {
          this.getSelectedTables.forEach((idToLock) => {
            var found = tablesIdsLocked.find((idLocked) => {
              return idLocked === idToLock
            })
            if (found === undefined) tablesIdsLocked.push(idToLock)
          })
          this.updateCurrentServiceLockedTables({
            date: this.getSelectedDay,
            room: this.getSelectedRoom,
            service: this.getSelectedMainService,
            tablesIds: tablesIdsLocked
          }).then(() => {
            this.btnLockTable = false
          })
        } else {
          let newTablesIdsLocked = []
          tablesIdsLocked.forEach((idToLock) => {
            var found = this.getSelectedTables.find((idLocked) => {
              return idLocked === idToLock
            })
            if (found === undefined) newTablesIdsLocked.push(idToLock)
          })
          this.updateCurrentServiceLockedTables({
            date: this.getSelectedDay,
            room: this.getSelectedRoom,
            service: this.getSelectedMainService,
            tablesIds: newTablesIdsLocked
          }).then(() => {
            this.btnLockTable = false
          })
        }
      }
    },
    takeResaOnThisTable: function () {
      this.setPopupTakeResa(true)
      this.setPopupTableSelected(false)
    },
    unLinkTable: function () { }
  }
}
</script>

<style lang="scss"></style>
